import { createReducer, on } from '@ngrx/store';
import * as SelectionActions from './selection.actions';

export interface SelectionState {
    selectedItem: string;
    selectedSection: string;
    callerRole: string;
    userAuthenticated: boolean | null;  // null = not yet manually set (use API value)
}

export const initialState: SelectionState = {
    selectedItem: '',
    selectedSection: '',
    callerRole: '',
    userAuthenticated: null,
};

export const selectionReducer = createReducer(
    initialState,
    on(SelectionActions.setSelectedItem, (state, { item }) => ({
        ...state,
        selectedItem: item,
    })),
    on(SelectionActions.setSelectedSection, (state, { section }) => ({
        ...state,
        selectedSection: section,
    })),
    on(SelectionActions.setCallerRole, (state, { role }) => ({
        ...state,
        callerRole: role,
    })),
    on(SelectionActions.setUserAuthenticated, (state, { isAuthenticated }) => ({
        ...state,
        userAuthenticated: isAuthenticated,
    }))
);
